export default "__VITE_ASSET__DhnONokY__"